/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * @author Gladson Samuel S
 * AssignmentProgressCardStyles.js
 * Styles for assignment progress card components
 */

import { makeStyles } from '@material-ui/core';
import mixins from '../../../assets/styles/mixins.scss';
import CommonStyles from '../../../assets/styles/CommonStyles';

const useAssignmentProgressCardStyles = makeStyles({
  card: {
    '&.theme-dark': {
      '--card-bg': mixins.darkThemeBgColor,
      '--card-text': mixins.darkThemeTextColorPrimary,
      '--card-bg-2': mixins.darkThemeBgColor2,
      '--muted-text': mixins.darkThemeTextColorTertiary,
      '--progress-bar-bg': mixins.darkProgressBgColor
    },
    '&.theme-light': {
      '--card-bg': mixins.chalkWhiteFont,
      '--card-text': mixins.color_text_primary,
      '--card-bg-2': mixins.lightThemeBgColor2,
      '--muted-text': mixins.zambezi,
      '--progress-bar-bg': mixins.quaternary
    },

    borderRadius: 16,
    backgroundColor: 'var(--card-bg)',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    minWidth: 366,

    '& *': {
      boxSizing: 'border-box'
    },
    '& > *': {
      width: '100%'
    }
  },
  header: {
    display: 'flex',
    gap: 8,
    justifyContent: 'space-between',
    minHeight: 44
  },
  footer: {
    display: 'flex',
    gap: 8,
    justifyContent: 'space-between'
  },
  title: {
    color: 'var(--card-text)',
    fontFeatureSettings: '\'liga\' off',
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '22px',
    ...CommonStyles().truncateNumberOfLines(2)
  },
  content: {
    padding: '4px 0px',
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },
  sectionsContainer: {
    marginTop: 0,
    flexWrap: 'wrap'
  },
  sectionsLabel: {
    color: 'var(--card-text)',
    fontFeatureSettings: '\'liga\' off',
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '20px'
  },
  sectionChip: {
    background: 'var(--card-bg-2)'
  },
  sectionNumber: {
    color: 'var(--card-text)'
  },
  sectionTextContainer: {
    padding: 0
  },
  footerRightText: {
    color: 'var(--muted-text)',
    textAlign: 'right',
    fontFeatureSettings: '\'liga\' off',
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '20px'
  },
  badge: {
    borderRadius: 4
  },
  progressBar: {
    width: '100%',
    cursor: 'pointer'
  },
  progressBarContainer: {
    minHeight: 10
  },
  progressBarWrapperButton: {
    ...CommonStyles().buttonReset
  }
});

export default useAssignmentProgressCardStyles;
